<template>
  <div>
    <v-subheader class="title-setting">Recepción</v-subheader>

    <v-form @submit.prevent ref="form" v-model="valid" class="py-4 px-4" v-on:submit.prevent="save">
      <v-row>
        <v-col cols="12">
          <v-switch
            v-model="item.allow_reopen_asn"
            label="Permitir reabrir ASN cerrados"
            hint="Habilita la acción 'Reabrir' en el listado de ASN (solo web). Al reabrir se notifica al cliente por webhook."
            persistent-hint
            color="primary"
            :loading="loading_settings"
          />
        </v-col>

        <v-col cols="12" class="text-right mt-4">
          <v-btn :loading="loading" color="success" type="submit">Guardar</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import ValidMixin from "@/mixins/ValidMixin.vue";

export default {
  props: {
    mainItem: Object,
    createItem: Function,
    loading: Boolean,
    loading_settings: Boolean
  },
  mixins: [ValidMixin],
  watch: {
    mainItem: {
      handler(newVal) {
        this.item = JSON.parse(JSON.stringify(newVal));
      },
      immediate: true,
      deep: true
    }
  },

  data() {
    return {
      item: JSON.parse(JSON.stringify(this.mainItem)), // copia profunda para evitar mutar la prop
    };
  },
  methods: {
    save(e) {
      if (this.valid) {
        this.$emit("createItem", e, this.item, 'recepcion');
      } else {
        console.log("Formulario no válido");
      }
    },
  },
};
</script>
